// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"a93b488b","488":"1a17cd5c"}[chunkId] + ".chunk.js";
};